var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tab-item",
    [
      _vm.loading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _c(
            "v-list",
            [
              _vm._l(_vm.items, function (p) {
                return _c(
                  "v-list-item",
                  { key: p._id },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "pharmacy-link",
                                attrs: {
                                  href: `${_vm.linkBase}/${p._id}`,
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(p.name) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.mutualIds && _vm.mutualIds.has(String(p._id))
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      color: "red",
                                      small: "",
                                      title: "Beidseitig favorisiert",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            mdi-heart\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.items.length && !_vm.loading
                ? _c(
                    "v-list-item",
                    [
                      _c("v-list-item-title", { staticClass: "grey--text" }, [
                        _vm._v(
                          "\n        " + _vm._s(_vm.emptyText) + "\n      "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }